module.exports = __webpack_public_path__ + "img/logo.5287b56c.png";